export function isDate(value) {
  return value instanceof Date && !isNaN(+value);
}



// WEBPACK FOOTER //
// ./src/app/services/utils/is-date.ts